import { render } from "./DashboardRankList.vue?vue&type=template&id=6d550120&scoped=true"
import script from "./DashboardRankList.vue?vue&type=script&lang=js"
export * from "./DashboardRankList.vue?vue&type=script&lang=js"

import "./DashboardRankList.vue?vue&type=style&index=0&id=6d550120&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d550120"]])

export default __exports__